export default "__VITE_ASSET__94c49ae8__"